import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import VeersaLoaderGif from "../../common/icons/Veersa-loader.gif";

export default function Loader() {
  return (
    <div>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={true}
      >
        <div style={{
          backgroundColor: 'white',
          padding: '15px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <img 
            src={VeersaLoaderGif} 
            alt="Loading..." 
            style={{ width: '78px', height: '78px', marginBottom: '10px' }}
          />
          <span style={{ color: '#1976d2', fontSize: '14px', fontWeight: '500' }}>Loading...</span>
        </div>
      </Backdrop>
    </div>
  );
}
